module.exports = __webpack_public_path__ + "static/media/26UNRWA11.86abb1b6.jpg";